import { BaseControl } from '.';

/**
 * @typedef {object} BooleanControlOptions
 */

/**
 * @extends {BaseControl<boolean, BooleanControlOptions>}
 */
export class BooleanControl extends BaseControl {

    /** @type {BaseControl<boolean>['render']} */
    render(value, onChange) {
        return (
            <div className="boolean-control">
                <div className="boolean-control-header">
                    <label className="boolean-control-label">
                        {this.label}
                    </label>
                    <div className="toggle-container">
                        <label className="toggle-switch">
                            <input 
                                type="checkbox" 
                                checked={value} 
                                onChange={(e) => onChange(e.target.checked)}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                </div>
                {this.description && (
                    <p className="boolean-control-description">
                        {this.description}
                    </p>
                )}
            </div>
        );
    }
}
